import classNames from 'classnames'

import { DotsLoader } from 'app/common/components/Loader'
import type { DietFoodTypeId, DietFoodType } from 'app/dataTypes/org/dietFoodTypes'

import navStyles from 'app/common/ui/PlainNav/PlainNav.module.scss'
import navItemStyles from 'app/common/ui/PlainNav/NavItem.module.scss'

import styles from './SelectorDietFoodTypes.scss'


type Props = {
  items: Array<DietFoodType>
  scrollable?: boolean
  title?: string
  loading?: boolean
  className?: string
  selectedId?: DietFoodTypeId | null
  onSelect: (id: DietFoodTypeId | null) => void
}

type Item = {
  id: DietFoodTypeId | null
  title: string
}



const SelectorDietFoodTypes = ({
  items,
  scrollable,
  title,
  loading,
  className,
  selectedId,
  onSelect,
}: Props) => {
  const sortedItems = [...items].sort((a, b) => a.title.localeCompare(b.title, 'ru'))
  const itemsWithBase: Array<Item> = [
    { id: null, title: 'Базовый' },
    ...sortedItems,
  ]
  const currentSelectedId = selectedId ?? null

  const handleSelect = (id: DietFoodTypeId | null) => {
    if (id == null) {
      onSelect(null)
      return
    }
    onSelect(id)
  }

  return (
    <div
      className={classNames(navStyles.root, styles.root, className, {
        [navStyles.scrollable]: scrollable && !loading,
      })}
    >
      {title && (
        <div className={classNames(navStyles.title, { [navStyles.titleFix]: scrollable })}>
          {`${title}:`}
        </div>
      )}
      {loading ? (
        <DotsLoader className={styles.loader} />
      ) : (
        <div className={classNames(navStyles.items, styles.items)}>
          {itemsWithBase.map(item => {
            const isActive = item.id == null
              ? currentSelectedId == null
              : currentSelectedId != null && item.id === currentSelectedId

            return (
              <button
                key={item.id == null ? 'base' : item.id}
                type="button"
                className={classNames(styles.button, navItemStyles.link, {
                  [navItemStyles.active]: isActive,
                })}
                onClick={() => handleSelect(item.id)}
                aria-pressed={isActive}
              >
                {item.title}
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default SelectorDietFoodTypes
